import { object, setLocale, string } from 'yup'

setLocale({
  // use constant translation keys for messages without values
  mixed: {
    required: 'common.required',
    notType: 'common.required'
  }
})
export default object().shape({
  policy_receipt_rule_prefix: string().required(),
  operator: string().required().typeError(),
  currency_id: string().required(),
  reason_id: string().required(),
  reference_id: string().required(),
  service_id: string().required()
})
